import React from "react";
import { motion } from "framer-motion";

const CloseDockRangeModal = ({
  selection,
  dockName,
  reason,
  onReasonChange,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  const formatRangePart = (date) =>
    date
      ? date.toLocaleString([], {
          weekday: "short",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "-";

  return (
    <motion.div
      className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center px-fluid-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-xl p-fluid-4 space-y-fluid-3"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        <div className="flex items-start justify-between">
          <div>
            <div className="text-fluid-sm text-gray-500 mb-fluid-1">
              Close dock
            </div>
            <h2 className="text-fluid-xl font-semibold text-[#111827]">
              {dockName || "Dock"}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="rounded-lg border border-gray-200 bg-gray-50 p-fluid-3 space-y-fluid-1.5 text-fluid-sm text-gray-800">
          <div className="flex items-center justify-between gap-fluid-2">
            <span className="font-medium">From</span>
            <span>{formatRangePart(selection?.start)}</span>
          </div>
          <div className="flex items-center justify-between gap-fluid-2">
            <span className="font-medium">To</span>
            <span>{formatRangePart(selection?.end)}</span>
          </div>
        </div>

        <div className="space-y-fluid-1">
          <label className="text-fluid-sm font-medium text-gray-800">
            Reason
          </label>
          <input
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-fluid-sm focus:outline-none focus:ring-2 focus:ring-[#1e2a74]"
            placeholder="Maintenance"
          />
        </div>

        <div className="flex items-center justify-end gap-fluid-2">
          <button
            onClick={onClose}
            className="px-fluid-button-x py-fluid-button-y rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 text-fluid-sm"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubmitting}
            className="px-fluid-button-x py-fluid-button-y rounded-full bg-[#c63b2d] text-white font-semibold hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed text-fluid-sm"
          >
            {isSubmitting ? "Closing..." : "Close dock"}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default CloseDockRangeModal;
